import {useEffect, useRef, useState} from 'react';
import {ExecutionContainer} from '../../../types/model/framework/ExecutionContainer';
import {PostProcessorType} from '../../../types/postprocessor/PostProcessorType';
import {PostProcessorScript} from '../../../types/scripts/PostProcessorScript';

type usePostProcessingScriptProps = {
  projectId?: string;
  applicationId?: string;
  id?: string;
  hasPostProcessors?: boolean;
  fileName?: string;
  postProcessorType?: PostProcessorType;
  executionContainer?: ExecutionContainer;
  viewOnly?: boolean;
  onError?: (message?: string) => void;
};

export const usePostProcessingScript = ({
  projectId,
  applicationId,
  id,
  hasPostProcessors,
  fileName,
  postProcessorType,
  executionContainer,
  onError,
  viewOnly = false,
}: usePostProcessingScriptProps) => {
  const [module, setModule] = useState<PostProcessorScript>();
  const onErrorRef = useRef(onError);

  useEffect(() => {
    const fetchPostProcessor = async () => {
      try {
        // const url = 'data:text/javascript;base64,' + btoa(defaultDetectionPostProcessor);
        // const module = await import(/* webpackIgnore: true */ url);
        const module = await import(
          /* webpackIgnore: true */ `/studio/postprocessor/${
            viewOnly ? 'view' : 'edit'
          }/${projectId}/${applicationId}/${id}/${fileName}?type=${postProcessorType}&container=${executionContainer}&cachebust=${Date.now()}`
        );
        setModule(module);
      } catch (e) {
        onErrorRef.current?.('Error fetching post processor.');
        console.error(e);
      }
    };

    if (
      projectId &&
      applicationId &&
      id &&
      hasPostProcessors &&
      fileName &&
      postProcessorType &&
      executionContainer
    ) {
      fetchPostProcessor();
    }
  }, [
    projectId,
    applicationId,
    id,
    hasPostProcessors,
    fileName,
    postProcessorType,
    executionContainer,
    viewOnly,
  ]);

  return module;
};
